import { IApiMessage } from './message.types';

export const messageSerializer = (apiMessage: IApiMessage) => apiMessage;
